import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

// Only preloads routes explicitly opted in via `data: { preload: true }`
// (login / sign-up) so the header's Login/Sign Up links navigate instantly
// without a network wait, while heavier lazy chunks (dashboard, games)
// still load on demand instead of eating mobile bandwidth up front.
@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    return route.data?.['preload'] ? load() : of(null);
  }
}
